import {
  SELLING_UOM_DESCRIPTION,
  SELLING_UOM_MULTIPLIER,
} from '@lib/enums/selling-unit-of-measure';
import type { SellingUnitOfMeasure } from '@snap-types/models/enums';

/**
 * Scales a per-piece value into a site's selling unit — $0.01 each is $10 per
 * thousand.
 *
 * @NOTE This duplicates `perQuantityToSiteUnits` in
 * `@calculations/utilities/selling-uom`, which is the branded `Decimal`
 * version used at every boundary. This one exists because the configurator's
 * cost calculation works in plain numbers. Worth collapsing if that ever moves
 * to `Decimal`.
 */
export function perQuantityToSellingUnits(
  value: number,
  sellingUnitOfMeasure: SellingUnitOfMeasure,
): number {
  return value * SELLING_UOM_MULTIPLIER[sellingUnitOfMeasure];
}

export function appendSellingUnitDescription(
  value: string,
  sellingUnitOfMeasure: SellingUnitOfMeasure,
) {
  return `${value}${SELLING_UOM_DESCRIPTION[sellingUnitOfMeasure]}`;
}
